export default __webpack_public_path__ + "static/media/ECAInCharge.cc15225d.jpg";